export default {
  colors: {
    primary: {
      50: '#ECF2FE',
      100: '#D5E2FC',
      200: '#BBD3FA',
      300: '#95BBF8',
      400: '#6A9FF4',
      500: '#4886F0',
      600: '#276EE8',
      700: '#0152D9', // normal
      800: '#0134B5',
      900: '#001F97',
    },
    error: {
      50: '#FDECEE',
      100: '#F9D7D9',
      200: '#F8B9BE',
      300: '#F78D94',
      400: '#F36D78',
      500: '#E34D59', // normal
      600: '#C9353F',
      700: '#B11F26',
      800: '#951114',
      900: '#680506',
    },
    success: {
      50: '#E8F8F2',
      100: '#BCEBDC',
      200: '#85DBBE',
      300: '#48C79C',
      400: '#00A870', // normal
      500: '#078D5C',
      600: '#067945',
      700: '#056334',
      800: '#044F2A',
      900: '#033017',
    },
    warning: {
      50: '#FEF3E6',
      100: '#F9D7D9',
      200: '#F8B9BE',
      300: '#F2995F',
      400: '#ED7B2F', // normal
      500: '#D35A21',
      600: '#BA431B',
      700: '#9E3610',
      800: '#842B0B',
      900: '#5A1907',
    },
    // 中性色
    neutral: {
      100: '#F3F3F3',
      200: '#EEEEEE',
      300: '#E7E7E7',
      400: '#DCDCDC',
      500: '#C5C5C5',
      600: '#A6A6A6',
      700: '#8B8B8B',
      800: '#777777',
      900: '#5E5E5E',
      1000: '#4B4B4B',
      1100: '#383838',
      1200: '#2C2C2C',
      1300: '#242424',
      1400: '#181818',
    },
    // 主题中性色
    themeNeutral: {
      100: '#F1F2F5',
      200: '#EBEDF1',
      300: '#E3E6EB',
      400: '#D6DBE3',
      500: '#BCC4D0',
      600: '#97A3B7',
      700: '#7787A2',
      800: '#5F7292',
      900: '#4B5B76',
      1000: '#3C485C',
      1100: '#2C3645',
      1200: '#232A35',
      1300: '#1C222B',
      1400: '#13161B',
    },
    // 暗黑色
    darkTheme: {
      50: '#F9F9FE',
      100: '#F3F4FA',
      200: '#EBECF4',
      300: '#DADDF0',
      400: '#C2C7DF',
      500: '#959DBF',
      600: '#717AA4',
      700: '#656E9C',
      800: '#3F456A',
      900: '#272C46',
      1000: '#1F2237',
      1100: '#161828', // normal
      1200: '#0F101D',
      1300: '#030308',
    },
  },
  fontColors: {
    gray: {
      100: '#191919',
      200: '#666666',
      300: '#999999',
      400: '#BDBDBD',
    },
    white: {
      100: '#FFFFFF',
      200: '#E6E6E6',
      300: '#8C8C8C',
      400: '#595959',
      500: '#424242',
    },
    // 暗黑色的文字颜色
    dark: {
      100: '#FFFFFF',
      200: '#D5D7E9',
      300: '#8A8C9E',
      400: '#606273',
      500: '#4D4F5F',
    },
  },
  fontWeights: {
    normal: 400,
    bold: 500,
    bolder: 600,
    extrabold: 700,
    black: 800,
    extrablack: 900,
  },
  fontSizes: {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 20,
    '2xl': 30,
    '3xl': 38,
  },
  // 新加
  // 容器背景颜色
  box: {
    background: '#fff',
    borderRadius: '4px',
  },
  button: {
    borderRadius: '4px',
  },

  // 默认圆角
  defaultBorderRadius: '4px',
}
